<template>
    <div>
        <avue-crud
                :option="option"
                :data="data"
                :page="page"
                @refresh-change="refreshChange"
                @search-change="searchChange"
                @row-save="store"
                @row-update="update"
                @row-del="del"
                @size-change="sizeChange"
                @current-change="currentChange"
                :upload-before="uploadBefore"
                ref="crud"
        >
        </avue-crud>
    </div>
</template>
<script>
  import curd from './Base/Crud'

  export default {
    mixins: [curd],
    name: 'CamerataUserOutExamine',
    props: ['defaultParams'],
    data() {
      return {
        url: '/camerata/user',
        // curd组件
        option: {
          viewBtn: false, // 查看按钮显隐
          addBtn: false, // 增加按钮显隐
          addBtnText: '新增同好会', // 新增按钮文案
          editBtn: false, // 修改按钮显隐
          editBtnText: '审核', // 修改按钮文案
          delBtn: true, // 删除按钮显隐
          delBtnText: '同意退出', // 删除按钮文案
          columnBtn: false, // 列显隐按钮
          headerAlign: 'center', // 表头居中
          align: 'center', // 表内容 居中
          searchMenuSpan: 5, // 搜索同行 搜索所占宽度
          index: true, // 行首 索引
          dialogClickModal: false, // 是否可以通过点击modal关闭Dialog
          column: [
            {
              label: '员工姓名',
              prop: 'user-username',
              span: 24,
              display: false
            },
            {
              label: '工号',
              prop: 'user_id',
              span: 24,
              display: false
            },
            {
              label: '所属部门',
              prop: 'user-class',
              span: 24,
            },
            {
              label: '在职状态',
              prop: 'user-status',
              span: 24,
              type: 'select',
              display: false,
              dicData: [{'label': '在职', 'value': 1}, {'label': '<span style="color: red">离职</span>', 'value': 2}]
            },
            {
              label: '员工手机号',
              prop: 'user-tel',
              span: 24,
              display: false
            },
            {
              label: '状态',
              prop: 'status',
              type: 'radio',
              dicData: [{label: '待审核', value: 0},{label: '通过', value: 1},{label: '申请退出中', value: 2}],
              span: 24,
            },
          ]
        }
      }
    },
    methods: {
      // 更新事件
      update(row, index, done, loading) {
        this.$confirm('每月5号前申请加入的当月通过，每月5号后申请加入的次月通过', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // 去除不必要元素
          this.$refs.crud.option.column.forEach((item) => {
            if (item.display === false || item.editDisplay === false) delete row[item.prop]
          });

          // 如果存在默认参数则带过去
          if (this.defaultParams) row = Object.assign({}, this.defaultParams, row );

          this.api.post(this.url + '/' + row.id, row, 'PATCH').then((re) => {
              loading();
              if (re && re.code === 0) {
                this.initialization();
                this.eventCallback('update');
                done()
              } else re && this.$message.error(re.msg || '网络错误')
            }
          )
        });
        done();
      }
    }
  }
</script>
